import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ModalService } from '@core/services/modal/modal.service';

@Component({
	selector: 'app-disabled-link-modal',
	templateUrl: './disabled-link-modal.component.html',
	styleUrls: ['./disabled-link-modal.component.scss', './disabled-link-modal.responsive.scss'],
})
export class DisabledLinkModalComponent implements OnInit {
	static readonly ID = crypto.randomUUID();

	constructor(
		public dialogRef: MatDialogRef<DisabledLinkModalComponent>,
		private modalService: ModalService,
	) {}

	ngOnInit() {
		this.modalService.liftUpModal(this.dialogRef);
	}

	closeDialog(): void {
		this.dialogRef.close();
	}
}
